var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-info",attrs:{"dark":"","x-small":"","fab":"","outlined":""},on:{"click":function($event){return _vm.showItem(_vm.data)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" mdi-eye ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }